// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__r3DO1","container":"Footer_container__geY__","link":"Footer_link__gh2xK","dropdownList":"Footer_dropdownList__CtFH8","copy":"Footer_copy__IzHFX"};